export default import.meta.ROLLUP_FILE_URL_Nk5svJQde1ZfAdpNJczSkw